<template>
    <div>
        <div class="tip" v-if="showTip" @click="showTip = false">
            <img src="@/assets/image/share_tip.png" alt="">
        </div>

    </div>
</template>

<script>

import api from '@/assets/js/api'
import native from '@/assets/js/native'
import native_zh from '@/assets/js/native_zh'

// console.log(native)
import { cookie } from '@/assets/js/utils'
import appENV from '@/assets/js/env';

export default {
    props: {
        taskId: {
            type: [Number, String],
            default: 0
        },
    },
    data () {
        return {
            actId: (window && window.actId),
            showTip: false,
            shareData: {}
        }
    },
    mounted () {
        let self = this;
        self.actId = self.query && self.query.__sa || (window && window.actId);

    },
    methods: {
        //// 1=微信 2=中行APP 3=中银APP
        async init (params = {}) {
            let self = this;
            let opt = Object.assign({}, {
                // url: 'https://prod.odmkf.com/third-test/zy-sdcj2022-ui/#/', // 测试分享地址
                url: 'https://act.odmkf.com/zhongyin/sdcj2022-ui/index.html', // 生产分享地址
                title: '投资大时代新年小惊喜', // 分享标题
                content: '中银基金跨年活动欢乐送好礼，快来参与吧！', // 分享描述
                success: function () {
                    self.shareSubApi();
                },
                imgUrl: 'https://act.odmkf.com/zhongyin/sdcj2022-ui/img/share.jpg?v2' // 分享icon (选填 其他必填)
            }, params)



            let shareKey = cookie.get('shareKey' + self.actId);
            let _params = {
                title: opt.title,
                timeline: opt.content,
                desc: opt.content,
                link: opt.url,
                imgUrl: opt.imgUrl,
                success: opt.success,
                fail: function () { }
                // success: function () { }
            }
            // console.log('微信分享')
            self.$wechat.share(_params);

        },
        async share (params = {}, taskId) {
            let self = this;
            console.log('share-task-id',self.taskId);
            let opt = Object.assign({}, {
                // url: 'https://prod.odmkf.com/third-test/zy-sdcj2022-ui/#/', // 测试分享地址
                url: 'https://act.odmkf.com/zhongyin/sdcj2022-ui/index.html', // 生产分享地址
                title: '投资大时代新年小惊喜', // 分享标题
                content: '中银基金跨年活动欢乐送好礼，快来参与吧！', // 分享描述
                imgUrl: 'https://act.odmkf.com/zhongyin/sdcj2022-ui/img/share.jpg?v2' // 分享icon (选填 其他必填)
            }, params)

            // self.taskId = taskId;
            if (!self.actId) {
                self.actId = window.actId;
            }
            self.showTip = true;
        },
        async shareSubApi () {
            // alert('分享成功回调')
            let self = this;
            console.log('分享成功回掉执行任务完成接口-开始');
            let res = await api('post', '/finishTask', {
                taskId: self.taskId
            }).catch(err => {
                self.loading = false;
            })
            let { data, code, msg } = res && res.data;
            if (code == 200) {
                // alert('提交任务接口成功:' + self.taskId)

                console.log('分享成功回掉执行任务完成接口-成功');
                self.showTip = false;

                if (data.hasReward && data.rewardType == 1) {
                    cookie.set('needShowPrizePop', 1);
                    cookie.set('rewardNum', data.rewardNum);
                } else {
                    cookie.set('needShowPrizePop', 0);
                }
                setTimeout(() => {
                    self.$emit('handleShareSucc');

                }, 300)
            }
        },
        getShareUrl () {
            let self = this;
            let shareKey = cookie.get('shareKey' + self.actId);
            // 测试分享链接
            // return location.href.substr(0,location.href.indexOf('#'))+'#/' + ((shareKey&&shareKey.length)?shareKey:'') ;
            // return 'http://act.odmhl.com/third-test/zyact11/api/page1/jump' + ((shareKey && shareKey.length) ? shareKey : '');
            // 生产分享链接，使用动态跳转防止封禁
            // return 'https://weixin.bocim.com/activity/api-act3years/api/page1/jump' + ((shareKey&&shareKey.length)?shareKey:'') ;
            return 'https://act.odmkf.com/zhongyin/sdcj2022-ui/index.html';
        }
    },
}
</script>

<style lang="less">
@import '../assets/css/base.less';

.tip {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
    background-color: rgba(0, 0, 0, 0.4);

    img {
        width: 100%;
    }
}
</style>